import { render, staticRenderFns } from "./BotPicker.vue?vue&type=template&id=9dc9eb66"
import script from "./BotPicker.vue?vue&type=script&lang=js"
export * from "./BotPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports